import React, { useState } from 'react';
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Typography, Toolbar, Card, Grid, IconButton } from '@material-ui/core';


import EditIcon from '@material-ui/icons/Edit';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@material-ui/icons/Visibility';
import { Button } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { stakeHoldersData } from './StakeHoldersData'

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },

  trRow: {
    '& td': {
      padding: 6
    }
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1
  },
  gridContainerOuter: {
    margin: '6px -6px',
    display: 'flex',
    justifyContent: 'center'
  },
  gridItemInner: {
    padding: '0px 6px'
  },
  titleDiv: {
    padding: '8px 0px 12px 0px'
  },
});


export default function StakeHolders() {
  const classes = useStyles();
  const history = useHistory();
  const [stakes, setStakes] = useState(stakeHoldersData)
  const [deleteConfirmOpen, setdeleteConfirmOpen] = useState(false)
  const [selected, setSelected] = useState();


  const deleteHandler = (id) => {
    console.log('deleteHandler', id)
    setSelected(id)
    setdeleteConfirmOpen(true)
  }

  const deleteHandleClose = (val) => {
    if (val === "yes") {
      let orders_ = stakes.filter(({ id }) => id != selected)
      setStakes(orders_)
      setdeleteConfirmOpen(false)
    } else {
      setdeleteConfirmOpen(false)
    }
  }

  const editHandler = (row) => {
    console.log('editHandler', row)
    history.push(`/stakeholder/edit/${row.id}`)
  }
  const viewHandler = (row) => {
    console.log('editHandler', row)
    history.push(`/stakeholder/view/${row.id}`)
  }

  return (

    <div className={classes.root}>

      <div className={classes.titleDiv}>
        <Typography variant="h2">Stake Holders List</Typography>
      </div>

      <Grid container className={classes.gridContainerOuter}>
        <Grid item xs={12} className={classes.gridItemInner}>

          <Card >
            <Toolbar>
              <Typography variant="h6" >StakeHolders List</Typography>
            </Toolbar>
            <TableContainer >
              <Table className={classes.table} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Id</TableCell>
                    <TableCell >Holder Name</TableCell>
                    <TableCell align="center">Number Of Shares</TableCell>
                    <TableCell align="center">Value Of Investment</TableCell>
                    <TableCell align="center">Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody >
                  {stakes.map((row) => (
                    <TableRow key={row.id} className={classes.trRow}
                      hover
                    >
                      <TableCell component="th" scope="row">
                        {row.id}
                      </TableCell>
                      <TableCell >
                        {row.holderName}
                        <p>{row.email}</p>
                      </TableCell>
                      <TableCell align="center">{row.numberOfShares}</TableCell>
                      <TableCell align="center">{row.valueOfInvestment}</TableCell>
                      <TableCell align="center">
                        <IconButton onClick={() => viewHandler(row)}>
                          <VisibilityIcon />
                        </IconButton>
                        <IconButton onClick={() => editHandler(row)}>
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => deleteHandler(row.id)}>
                          <DeleteForeverIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>

        </Grid>

        <Dialog
          open={deleteConfirmOpen}
          onClose={() => deleteHandleClose('')}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Delete Confirmation"}</DialogTitle>
          <DialogContent dividers>
            <DialogContentText id="alert-dialog-description">
              Are you sure, do you want to delete!
          </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => deleteHandleClose('yes')} color="primary">
              yes
          </Button>
            <Button onClick={() => deleteHandleClose('no')} color="secondary" autoFocus>
              no
          </Button>
          </DialogActions>
        </Dialog>


      </Grid>
    </div>
  );
}